import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import config from '../config';

export const fromDateToTimeStamp = (date) => {
  return firebase.firestore.Timestamp.fromDate(date);
};

function getFirebaseConfig() {
  return fetch(`${config.baseUrl}/firebase-config`, {
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((response) => {
    return response.json();
  });
}

export async function init() {
  // For supporting multiple firebase instances https://github.com/vercel/next.js/issues/1999
  if (!firebase.apps.length) {
    const config = await getFirebaseConfig();
    const firebaseApp = firebase.initializeApp(config);
    if (config.useEmulator) {
      console.log('Use firebase emulator');
      firebase.auth().useEmulator('http://localhost:9099');
      firebase.firestore().useEmulator('localhost', 8080);
    }
    firebaseApp.serverTimestamp = firebase.firestore.FieldValue.serverTimestamp();
    return firebaseApp;
  } else {
    return firebase.app();
  }
}

let appPromise = null;

export async function getFirebaseApp() {
  if (!appPromise) {
    appPromise = init();
  }
  return appPromise;
}
